




























































































































































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class LogBody extends Vue {
  @Prop() readonly data!: any;

  @Prop() readonly multiCurrency!: any;

  @Prop() readonly col!: number;

  @Prop() readonly fetchWinloseAgent!: Function;

  @Prop() readonly fetchResult!: Function;

  @Prop() readonly totalLog!: number;

  @Prop() readonly summaryLog!: number;

  @Prop() readonly paginationDetail!: object;

  utilsInstance = utils;

  accurryDecimal = ['USD', 'NZD', 'KWD'];

  handleSub(username, role) {
    this.fetchWinloseAgent(username, role);
  }

  mapNumber(num) {
    if (num) return Number(num.$numberDecimal);
  }

  getDateTimeStamp(date) {
    return this.$moment(date).format('YYYYMMDD') >= 20240227;
  }
}
